// src/components/SubjectFormModal.js
import React, { useState } from "react";

export default function SubjectFormModal({ subject, onClose, onSave }) {
  const [form, setForm] = useState(subject);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(form);
  };

  return (
    <div
      className="modal fade show"
      style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              {form.id ? "Edit Subject" : "Add Subject"}
            </h5>
            <button className="btn-close" onClick={onClose}></button>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              <div className="mb-2">
                <label className="form-label">Subject Code</label>
                <input
                  type="text"
                  name="code"
                  className="form-control"
                  value={form.code}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-2">
                <label className="form-label">Subject Name</label>
                <input
                  type="text"
                  name="name"
                  className="form-control"
                  value={form.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="row">
                <div className="col-md-6 mb-2">
                  <label className="form-label">Grade Level</label>
                  <input
                    type="text"
                    name="gradeLevel"
                    className="form-control"
                    value={form.gradeLevel}
                    onChange={handleChange}
                  />
                </div>
                <div className="col-md-6 mb-2">
                  <label className="form-label">Strand</label>
                  <input
                    type="text"
                    name="strand"
                    className="form-control"
                    value={form.strand}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="mb-2">
                <label className="form-label">Teacher</label>
                <input
                  type="text"
                  name="teacher"
                  className="form-control"
                  value={form.teacher}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-2">
                <label className="form-label">Schedule</label>
                <input
                  type="text"
                  name="schedule"
                  className="form-control"
                  placeholder="e.g., Mon/Wed/Fri 8:00AM - 9:00AM"
                  value={form.schedule}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-2">
                <label className="form-label">Room</label>
                <input
                  type="text"
                  name="room"
                  className="form-control"
                  value={form.room}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={onClose}>
                Cancel
              </button>
              <button type="submit" className="btn btn-primary">
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
